import type { PriceId } from '@iheartjane/types';
import { PriceIdEnum } from '@iheartjane/types';

export const isPriceId = (priceId: string | null): priceId is PriceId => {
  return PriceIdEnum.includes(priceId as PriceId);
};
